import { messages } from '@databases/intl/messages';
import { useIntl } from 'react-intl-next';

import { isMac } from './toolbar-constants.ts';

export function useToolbarShortcutKeys() {
  const { formatMessage } = useIntl();

  const modHint = isMac ? '⌘' : `${formatMessage(messages['quick-search.ctrl'])}+`;
  const shiftHint = isMac
    ? '⇧'
    : `${formatMessage(messages['rich-text-formatting-toolbar.shift'])}+`;

  return { modHint, shiftHint };
}
